module.exports = __webpack_public_path__ + "static/illustrazione-capitolo-4-b097cc1c9da2ace2e6eb33ff7dc7b116.svg";